module.exports = __webpack_public_path__ + "media/fresh/scholarships-eba35d8b.svg";